import routes from "./routes.component";
import routesUrls from "./routes.urls";
import RoutesTransforms from "./routes.transforms";

const routesModule = angular
  .module("app.components.routes", [])
  .component("routesPage", routes)
  .service("RoutesTransforms", RoutesTransforms)
  .config(routesUrls);

export default routesModule;



// WEBPACK FOOTER //
// ./src/pages/routes/routes.module.js